import { Controller } from "@hotwired/stimulus";

/**
 * Broadcasts the survey title as the user types in the Settings drawer so the
 * builder header (`_builder_header.html.erb`) can mirror it live. The settings
 * form auto-saves with `autosave=1` and the server replies `head :ok`, so
 * there is no server-driven HTML refresh to update the `<h1>` after a save —
 * this controller closes that gap purely on the client.
 *
 * Mounts on the title `<input>` itself. On every `input` event it dispatches
 * a `survey:title-changed` window CustomEvent with `{ detail: { title } }`,
 * which `survey_header_title_controller.ts` listens for. No debounce — the
 * header should track the user's keystrokes 1:1 so the edit feels live.
 *
 * Harmless on pages without a listener (e.g. `/surveys/new`): the event fires
 * into the void.
 */
export default class extends Controller<HTMLInputElement> {
  private boundOnInput = () => this.broadcast();

  connect() {
    this.element.addEventListener("input", this.boundOnInput);
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundOnInput);
  }

  private broadcast() {
    window.dispatchEvent(
      new CustomEvent("survey:title-changed", {
        detail: { title: this.element.value },
      }),
    );
  }
}
